import { jsonProperty, Serializable } from "ts-serializable";

class ExameCard extends Serializable {
  @jsonProperty(String, null)
  id: string = "";

  @jsonProperty(String, null)
  nomeExame: string = "";

  @jsonProperty(String, null)
  dataColeta: string = "";
}

export default ExameCard;